<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(:title="dialogTitle" @close="onCancel")
      yz-dialog-normal-content.pa-6
        .text-neutral-700
          .yz-regular-body-sm.mb-4
            div This date will be applied to all selected documents.
            div You can still edit each one individually later.

          .yz-medium-body-sm {{ dateLabel }}
          yz-text-field.mt-1(v-model="formattedSelectedDate" placeholder="Select a date" prepend-inner-icon="$yzi-calendar" readonly clickable clearable size="md" required :rules="dateRules" required-error-message="Date is required" @click="datePickerDialog = true" @click:clear="selectedDate = null")
      yz-dialog-normal-actions(cancel-label="Cancel" save-label="Apply to all" :disable-save="!canSave" @cancel="onCancel" @save="onConfirm")

    // Date Picker Dialog
    yz-dialog(v-model="datePickerDialog" max-width="380px")
      yz-card
        yz-dialog-normal-content.px-2.pt-2.pb-0
          yz-date-picker(v-model="selectedDate" scrollable, @change="datePickerDialog = false")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      required: true,
      validator: (value) => ['approved', 'rejected', 'received'].includes(value)
    }
  },
  data() {
    return {
      selectedDate: new Date().toISOString().split('T')[0],
      datePickerDialog: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    dialogTitle() {
      const titles = {
        approved: 'Set approved date',
        rejected: 'Set rejected date',
        received: 'Set received date'
      }
      return titles[this.status]
    },
    dateLabel() {
      const labels = {
        approved: 'Approved date',
        rejected: 'Rejected date',
        received: 'Received date'
      }
      return labels[this.status]
    },
    formattedSelectedDate() {
      if (!this.selectedDate) return ''
      return DateTime.fromISO(this.selectedDate).toFormat('dd/MM/yyyy')
    },
    dateRules() {
      return [
        v => !!v || 'Date is required'
      ]
    },
    canSave() {
      return !!this.selectedDate
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed', this.selectedDate)
      this.showDialog = false
    },
    onCancel() {
      this.$emit('canceled')
      this.showDialog = false
    }
  }
}
</script>

<style scoped></style>
